export const isProductionEnvironment = (): boolean => {
  return !!process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === "production";
};
